// import axios from "axios";
import api from "./apiConfig";


export const getAllProducts = async (data) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const productsCall = await api.get('/products', { params: data, headers: { 'x-auth-token': localStorage.getItem('token') } })
            let status = productsCall?.data?.status;
            let successData = productsCall?.data?.data;
            let message = productsCall?.data.message;

            if (status !== 200) {
                resolve([{ message, status }, null])
            } else {
                resolve([null, successData])


            }
        } catch (error) {
            // send error back
            // reject(error)
            resolve([{ message: error, status: 500 }, null])
        }
    })
}




export const createProducts = async (data) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const productsCall = await api.post('/products', data, {
                headers: { 'x-auth-token': localStorage.getItem('token') }
            }); // submitting the array of customer objects

            let status = productsCall?.data?.status;
            let successData = productsCall?.data?.data;
            let message = productsCall?.data.message;

            if (status !== 200) {
                resolve([{ message, status }, null])
            } else {
                resolve([null, successData])


            }
        } catch (error) {
            // send error back
            reject(error)
        }
    })
}

export const updateProduct = async (product) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const productId = product.id || product._id;
            const response = await api.put(`/products/${productId}`, {
                ...product,
            },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-auth-token': localStorage.getItem('token')
                    },
                    body: JSON.stringify(product),
                });
            let status = response?.data?.status;
            let successData = response?.data?.data;
            let message = response?.data?.message;

            if (status !== 200) {
                resolve([{ message, status }, null]);
            } else {
                resolve([null, successData]);
            }
        } catch (error) {
            console.error('Error updating product:', error);
            throw error;
        }
    })
};

export const deleteProduct = async (productId) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const response = await api.delete(`/products/${productId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-auth-token': localStorage.getItem('token')
                },
            });
            let status = response?.data?.status;
            let successData = response?.data?.data;
            let message = response?.data?.message;

            if (status !== 200) {
                resolve([{ message, status }, null]);
            } else {
                resolve([null, successData]);
            }
        } catch (error) {
            console.error('Error deleting product:', error);
            reject(error);

        }
    })
};

export const getTotalProducts = async () => {
    try {
        const response = await api.get(`/products/total`, {
            headers: { 'x-auth-token': localStorage.getItem('token') }
        });
        return response.data.message.total;
    } catch (error) {
        throw error;
    }
};